import request from "@utils/request";

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig() {
  return request.post(
    "/api/v1/wechat/getSignature",
    { url: document.location.href },
    // { url: "http://datum.lishuedu.com/" },
    { login: false }
  );
}
export function getWechatConfigBuy() {
  return request.post(
    "/api/v1/wechat/getSignature",
    // { url: "http://datum.lishuedu.com/buyDetail/" },
    { url: document.location.href },
    { login: false }
  );
}
// get openid
export function getOpenId(code) {
  return request.post("/api/v1/wechat/getOpenId", {code}, {login: false});
}
// get openid
export function getSchoolByOpenId(openId) {
  return request.post("/api/v1/wechat/getSchoolByOpenId", {openId}, {login: false});
}
/**
 * 
 * @returns {*}
 */

export function toAuth(scope, from) {
  return request.post("/api/v1/wechat/p1/public/toAuth", {scope, from}, {login: false});
}

/**
 * 获取商品购买
 * @returns {*}
 */
export function getBuyProductList(recommendId) {
  return request.post("/api/v1/getBuyProductList", {recommendId}, {login: false});
}

/**
 * 获取商品列表
 * @returns {*}
 */
export function getHomeData(pageNum, pageSize, schoolId) {
  return request.post("/api/v1/getProductList", {pageNum, pageSize, schoolId}, {login: false});
}
/**
 * 获取商品购买列表
 * @returns {*}
 */
export function getBuyStudentList(productId, recommendId) {
  return request.post("/api/v1/getBuyStudentList", {productId, recommendId}, {login: false});
}

/**
 * 获取二维码列表
 * @returns {*}
 */
export function getCodeList(pageNum, pageSize, unionId) {
  return request.post("/api/v1/getQrCodeList", {pageNum, pageSize, unionId}, {login: false});
}

/**
 * 获取学校列表
 * @returns {*}
 */
export function getSchoolList(productId) {
  return request.post("/api/v1/getSchoolSelect", {productId}, {login: false});
}
/**
 * 获取年级列表
 * @returns {*}
 */
export function getGradeList(schoolId) {
  return request.post("/api/v1/getGradeSelect", {schoolId}, {login: false});
}
/**
 * 获取班级列表
 * @returns {*}
 */
export function getClassesList(gradeId) {
  return request.post("/api/v1/getClassesSelect", {gradeId}, {login: false});
}
/**
 * 获取二维码详细
 * @returns {*}
 */
export function getCodeDetail(id) {
  return request.post("/api/v1/getQrCodeDetail", {id}, {login: false});
}

/**
 * 获取商品信息
 * @returns {*}
 */
export function getProductDetail(id) {
  return request.post("/api/v1/getProductInfo", {id}, {login: false});
}

/**
 * 获取商品支付订单
 * @returns {*}
 */
export function getOrderInfo(openId, productId, unionId, amount, userName, phone, classes, classesId, grade, gradeId, school, schoolId) {
  return request.post("/api/v1/genOrder", {openId, productId, unionId, amount, userName, phone, classes, classesId, grade, gradeId, school, schoolId}, { login: false });
}

/**
 * 获取二维码信息
 * @returns {*}
 */
export function getRecommend(productId, unionId, url) {
  return request.post("/api/v1/recommend", {productId, unionId, url}, { login: false });
}

/**
 * 绑定手机
 * @returns {*}
 */
export function bindingPhone(phone, unionId, verifyCode) {
  return request.post("/api/v1/teacher/binding", {phone, unionId, verifyCode}, { login: false });
}


/**
 * 取消绑定手机
 * @returns {*}
 */
export function cancelBindingPhone(phone, unionId, verifyCode) {
  return request.post("/api/v1/teacher/solveUserBinding", {phone, unionId, verifyCode}, { login: false });
}


/**
 * 发送短信
 * @returns {*}
 */
export function sendSMS(phone) {
  return request.post("/api/v1/teacher/sendSMS", {phone}, { login: false });
}


/**
 * 文章列表
 * @returns {*}
 */
export function getArticleList(q, cid) {
  return request.post("/article/list/" + cid, q, { login: false });
}

/**
 * 分享
 * @returns {*}
 */
export function getShare() {
  return request.get("/share", {}, { login: false });
}

/**
 * 文章详情
 * @returns {*}
 */
export function getArticleDetails(id) {
  return request.get("/article/details/" + id, {}, { login: false });
}



/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function wechatAuth(code, spread, login_type) {
  return request.get(
    "/wechat/auth",
    { code, spread, login_type },
    { login: false }
  );
}
/**
 * 获取快递公司
 * @returns {*}
 */
export function getLogistics() {
  return request.get("/logistics", {}, { login: false });
}
